module.exports = __webpack_public_path__ + "media/images/athletes/1525-340dcf39f2c2f3a8937aaefc7306286c.png";